import { useQuery } from '@tanstack/react-query'

import { queryKeys } from '@/constants/queryKeys'
import { RegisterModel } from '@/http/models'

import { unwrap } from '../unwrap'

export const useRegister = (enabled = true) =>
  useQuery({ queryKey: queryKeys.register, queryFn: () => unwrap(RegisterModel.getCurrent()), staleTime: Infinity, enabled })
